<script>
import CalendarView from '@/views/ExtendableBases/CalendarView'

export default {
  extends: CalendarView,
  methods: {
    onCellClick() {}
  }
}
</script>
